import styled from "styled-components";
import { skeleton } from "styles/skeleton.style";

/**
 * Better loading UI component.
 * Displays an animated shimmer the size of the text.
 * See https://medium.com/octopus-wealth/skeleton-loading-pages-with-react-5a931f12677b
 */
const SkeletonLine = styled.div.attrs({ className: "skeleton-line" })`
  ${skeleton};

  border-radius: 3px;
  &::before {
    content: "\\00a0";
  }
`;

export default SkeletonLine;
